export const ORDER_STATUS_VALUES = {
  new: 'Черновик',
  send: 'Отправлен',
  work: 'В работе',
  finish: 'Завершен',
  refusal: 'Отказ',
  completed_part: 'Получено частично',
  completed: 'Получено полностью',
};

export const POSITION_STATUS_VALUES = {
  arrived: 'Поступил',
  inProgress: 'В работе',
  completed: 'Выполнен',
  refusal: 'Отказ',
};

export const ORDER_STATUS_KEYS = Object.entries(ORDER_STATUS_VALUES).reduce((result, [key, value]) => {
  result[value] = key;
  return result;
}, {});

export const POSITION_STATUS_KEYS = Object.entries(POSITION_STATUS_VALUES).reduce((result, [key, value]) => {
  result[value] = key;
  return result;
}, {});

const ORDER_STATUS_TRANSLATION_KEYS = {
  new: 'draft',
  send: 'sent',
  work: 'inWork',
  finish: 'completed',
  refusal: 'refusal',
  completed_part: 'completedPart',
  completed: 'received',
};

const ORDER_STATUS_KEY_ALIASES = {
  draft: 'new',
  sent: 'send',
  inWork: 'work',
  completedPart: 'completed_part',
  received: 'completed',
};

export const ORDER_STATUS_EN_LABELS = {
  new: 'Draft',
  send: 'Sent',
  work: 'In work',
  finish: 'Completed',
  refusal: 'Refusal',
  completed_part: 'Partially received',
  completed: 'Received',
};

function normalizeOrderStatusKey(key) {
  return ORDER_STATUS_KEY_ALIASES[key] || key;
}

export function getOrderStatusTranslationKey(status) {
  const key = ORDER_STATUS_KEYS[status];
  const translationKey = ORDER_STATUS_TRANSLATION_KEYS[key];
  return translationKey ? `orderPage.statuses.${translationKey}` : null;
}

export function translateOrderStatus(status, t, forceEnglish = false) {
  const key = ORDER_STATUS_KEYS[status];
  if (forceEnglish && key && ORDER_STATUS_EN_LABELS[key]) {
    return ORDER_STATUS_EN_LABELS[key];
  }

  const translationKey = getOrderStatusTranslationKey(status);
  return translationKey ? t(translationKey) : status;
}

export function isOrderStatus(status, key) {
  return ORDER_STATUS_KEYS[status] === normalizeOrderStatusKey(key);
}

export function isPositionStatus(status, key) {
  return POSITION_STATUS_KEYS[status] === key;
}
